import React, { useEffect, useRef, useState } from 'react';
import { apiClient } from '../services/api';
import './UnauthorizedScreen.css';

const FOOTER_DOCS = [
  {
    title: 'Términos del servicio',
    text: `Términos del servicio SanaSivana
1. Disposiciones generales
1.1. Los presentes Términos regulan el uso del servicio SanaSivana (en adelante, el «Servicio») por personas físicas (en adelante, el «Usuario»).
1.2. Al utilizar el Servicio, el Usuario confirma su aceptación de los presentes Términos y de las condiciones de la Oferta pública.
1.3. El Servicio proporciona acceso a las siguientes funciones:
— biblioteca de meditaciones;
— prácticas diarias;
— recomendaciones personalizadas;
— seguimiento del progreso;
— unidad virtual interna («estrellas»);
— suscripciones y paquetes;
— programa de referidos;
— otras funcionalidades indicadas en la interfaz.

2. Registro y cuenta
2.1. Para acceder al Servicio, el Usuario se autentica a través de Telegram u otros métodos disponibles.
2.2. Al registrarse, el Usuario proporciona los datos transmitidos automáticamente por Telegram (nombre, alias, ID) y confirma su veracidad.
2.3. El Usuario es responsable de mantener el acceso a su cuenta de Telegram y se compromete a no transferirla a terceros.
2.4. El Operador puede bloquear o eliminar la cuenta de un usuario que incumpla los presentes Términos o las condiciones de la Oferta pública.

3. Uso del servicio
3.1. El Servicio está destinado exclusivamente al uso personal del Usuario.
3.2. El Servicio no es una organización médica, no presta servicios médicos, psicoterapéuticos ni similares, y no emite diagnósticos. Todas las meditaciones, prácticas, textos y recomendaciones tienen carácter informativo y de apoyo.
3.3. El Usuario asume todos los riesgos derivados del uso del Servicio.
3.4. El Servicio puede incluir funciones de pago a las que se accede mediante suscripciones, paquetes o adquisición de estrellas.

4. Moneda interna y paquetes
4.1. El Servicio utiliza una unidad virtual interna: cristales.
4.2. Los cristales se adquieren con dinero real y solo pueden usarse dentro del Servicio para acceder a funciones de pago.
4.3. Los cristales no son dinero, moneda electrónica ni valores; carecen de valor nominal y no pueden cambiarse por dinero real u otros activos.
4.4. El Usuario puede adquirir paquetes de servicios que dan acceso a determinadas funciones o ventajas dentro del Servicio.
4.5. Los cristales y paquetes no son reembolsables ni canjeables, salvo en los casos previstos expresamente por la ley aplicable.

5. Prohibiciones para los usuarios
Queda prohibido al Usuario:
— usar el Servicio con fines comerciales sin el consentimiento del Operador;
— ceder el acceso a la cuenta a terceros;
— publicar o transmitir materiales falsos, ofensivos, agresivos o ilegales;
— intentar eludir los sistemas de pago o las restricciones de acceso;
— copiar, distribuir, modificar o utilizar los materiales del Servicio fuera de sus funciones;
— usar el Servicio para enviar spam, publicidad o llevar a cabo acciones fraudulentas;
— realizar acciones que puedan perjudicar el funcionamiento del Servicio o de Telegram.

6. Privacidad y datos
6.1. El tratamiento de los datos personales del Usuario se realiza conforme a la Oferta pública y la Política de privacidad.
6.2. El Usuario consiente el tratamiento de los datos transmitidos a través de Telegram (nombre, alias, ID), así como de estadísticas anonimizadas necesarias para el funcionamiento y la mejora del Servicio.
6.3. Contacto para consultas sobre datos: help@sanasivana.space.

7. Responsabilidad y limitaciones
7.1. El Servicio se proporciona «tal cual». El Operador no garantiza el funcionamiento ininterrumpido ni que el Usuario alcance los resultados esperados.
7.2. El Operador no es responsable de:
— las acciones del Usuario basadas en la información obtenida del Servicio;
— fallos técnicos causados por equipos o software del Usuario, Telegram o proveedores de telecomunicaciones;
— la imposibilidad de usar el Servicio por causas ajenas al Operador.
7.3. La responsabilidad total del Operador frente al Usuario se limita al importe efectivamente pagado por el Usuario en los últimos 30 días naturales.

8. Disposiciones finales
8.1. Los presentes Términos forman parte integral de la Oferta pública.
8.2. El Operador puede modificar los Términos de forma unilateral publicando una nueva versión en el Servicio.
8.3. El uso continuado del Servicio tras la publicación de cambios implica la aceptación de la nueva versión.`,
  },
  {
    title: 'Oferta pública',
    text: `OFERTA PÚBLICA DE ACCESO AL SERVICIO SanaSivana

1. Disposiciones generales
1.1. El presente documento «Oferta pública de acceso al servicio SanaSivana» (en adelante, la «Oferta») constituye la propuesta de OOO «Kyulchoro» (en adelante, el «Operador») para celebrar un contrato de prestación de servicios (en adelante, el «Contrato») con cualquier persona física capaz que acepte la Oferta (en adelante, el «Usuario»).
1.2. La Oferta está dirigida a personas físicas mayores de 18 años. El uso del Servicio por menores de 18 años no está permitido.
1.3. El Servicio SanaSivana es un complejo de software del Operador que incluye una mini-aplicación dentro de Telegram y software de servidor, y proporciona acceso a las siguientes funciones:
— biblioteca de meditaciones;
— prácticas diarias;
— seguimiento del progreso;
— recomendaciones personalizadas;
— suscripciones y paquetes;
— unidad virtual interna («estrellas»);
— programa de referidos.
1.4. La aceptación de la Oferta se realiza mediante:
- registro/autenticación en el Servicio a través de Telegram;
- contratación de una suscripción o compra de un paquete;
- recarga de la unidad virtual («cristales»);
- uso efectivo de las funciones de pago.
1.5. El Servicio SanaSivana ofrece al Usuario acceso a las funcionalidades mostradas en la interfaz y correspondientes a los planes, suscripciones y paquetes seleccionados.
1.6. El Servicio no es una institución médica y no presta servicios médicos, de telemedicina ni psicoterapéuticos. Los materiales tienen carácter informativo, educativo y de relajación.
1.7. El uso del Servicio implica la aceptación de esta Oferta, la Política de privacidad y demás documentos publicados.
1.8. El Operador puede modificar la Oferta publicando una nueva versión. Los cambios se aplican desde el momento de su publicación salvo indicación contraria.

2. Términos y definiciones
2.1. Servicio: el complejo de software SanaSivana en Telegram.
2.2. Operador: OOO «Kyulchoro».
2.3. Usuario: persona física que utiliza el Servicio.
2.4. Cuenta: conjunto de datos generados automáticamente al autenticarse en Telegram.
2.5. Meditaciones: materiales de audio o texto para la relajación y el apoyo personal.
2.6. Prácticas diarias: tareas y ejercicios cotidianos.
2.7. Suscripción: acceso de pago a funciones ampliadas del Servicio. Puede incluir renovación automática.
2.8. Unidad interna («cristales»): unidad virtual usada para acceder a determinadas funciones. No es moneda.
2.9. Paquete: conjunto de contenidos o funciones a precio fijo.
2.10. Programa de referidos: sistema de bonificaciones por invitar a nuevos usuarios.
2.11. Contenido: cualquier material dentro del Servicio.
2.12. Pago: fondos abonados por el Usuario.

3. Objeto de la oferta
El Operador proporciona acceso a las funcionalidades de SanaSivana:
— meditaciones;
— prácticas diarias;
— recomendaciones;
— seguimiento del progreso;
— suscripciones y paquetes;
— moneda virtual («estrellas»);
— programa de referidos.
Todos los servicios tienen carácter exclusivamente informativo y educativo.

4. Registro y cuenta
4.1. El registro se realiza a través de Telegram Web App. Se transmiten nombre, alias e ID.
4.2. La cuenta se crea automáticamente.
4.3. El Usuario es responsable del acceso a su cuenta de Telegram.
4.4. Está prohibido ceder la cuenta a terceros.
4.5. El Operador puede bloquear las cuentas de los infractores.

5. Derechos y obligaciones de las partes
El Usuario se compromete a cumplir la Oferta, utilizar el servicio solo para fines personales, no interrumpir el funcionamiento del servicio y abonar las suscripciones puntualmente.
El Operador se compromete a garantizar la disponibilidad del servicio e informar sobre cambios en las condiciones.

6. Pago y reembolsos
6.1. El pago se realiza a través de los sistemas de pago integrados de Telegram u otros agregadores.
6.2. Los «cristales» y paquetes no son reembolsables, salvo en los casos previstos por ley.
6.3. La suscripción puede incluir renovación automática: si hay un método de pago asociado, se renueva automáticamente.
6.4. Los «cristales» no son moneda, no tienen equivalente monetario, no se devuelven ni se cambian.
6.5. Los paquetes tienen una vigencia limitada.
6.6. No se realizan reembolsos tras la eliminación de la cuenta.

7. Responsabilidad de las partes
7.1. El Servicio no garantiza resultados.
7.2. Los materiales no constituyen recomendación médica.
7.3. El Usuario utiliza el contenido bajo su propia responsabilidad.
7.4. El Operador no es responsable de fallos de Telegram, del dispositivo o de la conexión del usuario.

8. Datos personales
8.1. El Usuario transmite sus datos personales al Operador automáticamente a través de Telegram.
8.2. Los datos personales incluyen:
— nombre / alias;
— ID de Telegram;
— datos técnicos transmitidos automáticamente.
8.3. Los datos se utilizan para el funcionamiento del servicio y análisis.
8.4. No se transfieren a terceros, salvo en los casos previstos por la ley.
8.5. El Usuario puede retirar su consentimiento, pero el acceso al servicio quedará suspendido.

9. Resolución de disputas
Reclamación previa en un plazo de 30 días; posteriormente, resolución judicial en el domicilio del Operador.

10. Disposiciones finales
La Oferta constituye el acuerdo completo. La invalidez de cláusulas aisladas no afecta al resto. El Operador tiene derecho a modificar la Oferta.

11. Datos del Operador
OOO «Kyulchoro»
Dirección: Bishkek, distrito Leninsky`,
  },
  {
    title: 'Consentimiento de datos',
    text: `Consentimiento para el tratamiento de datos personales en el servicio SanaSivana

Por el presente, yo, en calidad de Usuario del servicio SanaSivana (en adelante, el «Servicio»), libre y voluntariamente otorgo mi consentimiento a OOO «Kyulchoro» (en adelante, el «Operador») para el tratamiento de mis datos personales en las siguientes condiciones:

1. Datos personales objeto del tratamiento
Confirmo y acepto que el Operador trata los siguientes datos transmitidos automáticamente a través de Telegram o proporcionados por mí al usar el Servicio:
— ID de Telegram;
— nombre, alias y otros datos públicos de Telegram;
— datos técnicos necesarios para el correcto funcionamiento del Servicio (idioma de la interfaz, tipo de dispositivo, etc.);
— estadísticas anonimizadas de actividad en el Servicio.
El Operador no recopila ni trata categorías especiales de datos personales, información sobre salud, estado mental, diagnósticos u otros datos sensibles.

2. Finalidades del tratamiento
Mis datos personales podrán ser tratados por el Operador para:
— garantizar el funcionamiento del Servicio;
— proporcionar acceso a meditaciones, prácticas, recomendaciones, suscripciones y contenido;
— administrar la cuenta de usuario;
— atender solicitudes al servicio de soporte;
— cumplir las obligaciones de la Oferta pública;
— mejorar el Servicio y realizar análisis basados en datos anonimizados;
— enviar notificaciones relacionadas con el funcionamiento del Servicio.

3. Métodos de tratamiento
El tratamiento de datos personales se realiza mediante:
— recopilación, registro y almacenamiento;
— sistematización y anonimización;
— uso en las funcionalidades del Servicio;
— eliminación al finalizar el propósito del tratamiento.
El tratamiento se lleva a cabo tanto con medios automatizados como sin ellos.

4. Transferencia a terceros
4.1. El Operador no transfiere los datos personales del Usuario a terceros, salvo:
— en los casos previstos expresamente por la ley;
— cuando la transferencia sea necesaria para cumplir obligaciones con el Usuario (p. ej., a operadores de pago en el caso de suscripciones).
4.2. Queda excluida la venta, el intercambio o el uso de los datos con fines de marketing de terceros.

5. Período de conservación
Los datos personales se conservan por el Operador:
— durante el período de uso del Servicio;
— hasta que el Usuario elimine su cuenta;
— hasta la retirada del consentimiento.
Transcurrido el período de conservación, los datos se eliminan o anoninizan.

6. Derechos del Usuario
El Usuario tiene derecho a:
— obtener información sobre sus datos personales;
— solicitar su rectificación, actualización o corrección;
— retirar el consentimiento para el tratamiento;
— solicitar la cesación del tratamiento y la eliminación de los datos;
— dirigirse al servicio de soporte en materia de tratamiento de datos: help@sanasivana.space.
La retirada del consentimiento puede impedir el uso continuado del Servicio.

7. Retirada del consentimiento
Puedo retirar el presente consentimiento enviando una solicitud a: help@sanasivana.space.
Tras recibir la solicitud, el Operador cesa el tratamiento de los datos y los elimina en los plazos establecidos, salvo disposición legal en contrario.

8. Disposiciones finales
El presente consentimiento es válido desde el momento de su otorgamiento hasta su retirada.
El uso del Servicio implica la aceptación de las condiciones de tratamiento de datos descritas en este documento.`,
  },
  {
    title: 'Política de privacidad',
    text: `Política de privacidad del servicio SanaSivana

Fecha de entrada en vigor: 1 de enero de 2025

La presente Política de privacidad (en adelante, la «Política») describe cómo OOO «Kyulchoro» (en adelante, el «Operador») recopila, utiliza, almacena y protege los datos personales de los usuarios del servicio SanaSivana (en adelante, el «Servicio»).

1. Información general
1.1. El Operador se compromete a proteger la privacidad de los usuarios y garantizar la seguridad de sus datos personales.
1.2. Al utilizar el Servicio, el Usuario acepta los términos de la presente Política.
1.3. La presente Política se aplica a todos los usuarios del Servicio, independientemente del método de acceso al mismo.

2. Datos personales que se recopilan
2.1. El Operador puede recopilar los siguientes datos:
— identificador único de usuario (ID de Telegram);
— nombre, alias y foto de perfil de Telegram (si están disponibles públicamente);
— datos del dispositivo y del sistema operativo;
— idioma de la interfaz;
— datos de uso del Servicio: secciones visitadas, meditaciones reproducidas, duración de las sesiones;
— historial de suscripciones y pagos (sin datos de tarjetas bancarias).
2.2. El Operador no recopila datos sobre la salud, diagnósticos médicos ni categorías especiales de datos personales.
2.3. Los datos de pago son procesados exclusivamente por operadores de pago certificados; el Operador no almacena datos de tarjetas bancarias.

3. Finalidad del tratamiento de datos
3.1. Los datos personales se utilizan para:
— garantizar el funcionamiento técnico del Servicio;
— proporcionar acceso a meditaciones, prácticas y contenido personalizado;
— gestionar la cuenta del usuario y las suscripciones;
— atender solicitudes de soporte técnico;
— mejorar el Servicio mediante el análisis de datos anonimizados;
— enviar notificaciones relacionadas con el funcionamiento del Servicio;
— cumplir con los requisitos legales aplicables.

4. Base legal del tratamiento
4.1. El tratamiento de datos personales se realiza sobre la base de:
— el consentimiento del usuario;
— la necesidad de ejecución del contrato (Oferta pública) del que el usuario es parte;
— el cumplimiento de obligaciones legales del Operador.

5. Almacenamiento y protección de datos
5.1. Los datos personales se almacenan en servidores ubicados en territorio de la Federación de Rusia y/o en países que garantizan un nivel adecuado de protección de datos personales.
5.2. El Operador aplica medidas técnicas y organizativas para proteger los datos contra acceso no autorizado, pérdida, modificación o divulgación.
5.3. El acceso a los datos personales está limitado a los empleados que los necesiten para desempeñar sus funciones.

6. Transferencia de datos a terceros
6.1. El Operador no vende ni cede datos personales a terceros con fines comerciales.
6.2. Los datos podrán ser transferidos a terceros en los siguientes casos:
— a operadores de pago para procesar transacciones;
— a proveedores de infraestructura técnica que garanticen el funcionamiento del Servicio;
— cuando sea requerido por la legislación aplicable o por orden judicial.
6.3. Todos los terceros que reciban datos personales están obligados a protegerlos conforme a los requisitos legales aplicables.

7. Período de conservación
7.1. Los datos personales se conservan durante el período en que el usuario utiliza el Servicio.
7.2. Tras la eliminación de la cuenta, los datos se eliminan o anonimizan en un plazo de 30 días, salvo que la ley exija su conservación por un período mayor.
7.3. Los datos necesarios para el cumplimiento de obligaciones fiscales o legales podrán conservarse durante el plazo establecido por la legislación aplicable.

8. Derechos del usuario
8.1. El usuario tiene derecho a:
— acceder a sus datos personales y obtener información sobre su tratamiento;
— solicitar la rectificación de datos inexactos o incompletos;
— solicitar la eliminación de sus datos personales;
— retirar el consentimiento para el tratamiento de datos;
— presentar una reclamación ante el organismo de control competente.
8.2. Para ejercer sus derechos, el usuario puede dirigirse al servicio de soporte: help@sanasivana.space.

9. Cookies y tecnologías similares
9.1. El Servicio puede utilizar cookies y tecnologías similares para garantizar su correcto funcionamiento y mejorar la experiencia del usuario.
9.2. El usuario puede configurar su navegador para rechazar cookies, aunque esto puede afectar a la funcionalidad del Servicio.

10. Cambios en la Política
10.1. El Operador se reserva el derecho de modificar la presente Política en cualquier momento.
10.2. Los cambios entran en vigor desde el momento de su publicación en el Servicio.
10.3. El uso continuado del Servicio tras la publicación de cambios implica la aceptación de la nueva versión de la Política.
10.4. Si los cambios son significativos, el Operador notificará a los usuarios mediante el Servicio.

11. Contacto
Para cualquier consulta relacionada con el tratamiento de datos personales:
Correo electrónico: help@sanasivana.space
Operador: OOO «Kyulchoro», Bishkek, distrito Leninsky`,
  },
];

const LANDING_ES = {
  subtitle: 'Servicio online de meditaciones',
  title: 'SanaSivana — meditaciones para la calma, el enfoque y el equilibrio interior',
  description: 'Prácticas diarias de mindfulness, técnicas de respiración y sesiones de audio relajantes para reducir el estrés y mejorar la calidad de vida.',
  usersCount: '10 000+ usuarios',
  rating: '4.9 de valoración',
  meditationsCount: '200+ meditaciones',
  sleepBadge: 'El sueño mejoró en 2 semanas de práctica',
  whatTitle: 'Plataforma de salud mental y vida consciente',
  whatText: 'SanaSivana es una plataforma online con meditaciones y prácticas de mindfulness desarrolladas por profesionales. Ayudamos a miles de personas a encontrar el equilibrio interior en el ritmo de la vida moderna.',
  benefit1: 'Reducir el nivel de estrés',
  benefit2: 'Mejorar la calidad del sueño',
  benefit3: 'Aumentar la concentración',
  benefit4: 'Gestionar la ansiedad',
  benefit5: 'Desarrollar la resiliencia emocional',
  feature1: 'Meditaciones de audio',
  feature2: 'Ejercicios de respiración',
  feature3: 'Cursos de mindfulness',
  feature4: 'Prácticas diarias',
  whyTitle: '¿Te reconoces?',
  whyProblems: 'Problemas del ritmo de vida moderno',
  problem1: 'Estrés constante y sobrecarga',
  problem2: 'Dificultades de concentración',
  problem3: 'Problemas para dormir',
  problem4: 'Agotamiento emocional',
  whyPractices: 'La meditación regular',
  practice1: 'Reduce los niveles de cortisol',
  practice2: 'Mejora la calidad del sueño',
  practice3: 'Restaura los recursos mentales',
  practice4: 'Aumenta la resistencia al estrés',
  howTitle: 'Cuatro sencillos pasos hacia la calma',
  step1Title: 'Crea tu cuenta',
  step1Text: 'Registro rápido en 30 segundos. Sin datos innecesarios.',
  step2Title: 'Elige tu objetivo',
  step2Text: 'Sueño, reducción de estrés, concentración, control de la ansiedad — tú decides.',
  step3Title: 'Recibe recomendaciones',
  step3Text: 'Prácticas personalizadas según tu objetivo y nivel de experiencia.',
  step4Title: 'Practica cada día',
  step4Text: 'Haz seguimiento de tu progreso, crea un hábito y siente los cambios.',
  advantagesTitle: 'Por qué elegir SanaSivana',
  adv1Title: 'Interfaz intuitiva',
  adv1Text: 'Diseño claro — empieza a meditar desde el primer minuto.',
  adv2Title: 'Adaptado a tus metas',
  adv2Text: 'El algoritmo seleccionará prácticas según tu objetivo: sueño, estrés, concentración.',
  adv3Title: 'Desde 5 minutos',
  adv3Text: 'Sesiones cortas que encajan en cualquier agenda — por la mañana, al mediodía o por la noche.',
  adv4Title: 'Contenido nuevo',
  adv4Text: 'Actualizaciones periódicas: nuevas meditaciones, cursos y prácticas cada semana.',
  adv5Title: 'Seguridad de datos',
  adv5Text: 'Tus datos están protegidos y nunca se comparten con terceros.',
  ctaTitle: 'Empieza gratis ahora mismo',
  ctaSubtitle: 'Únete a miles de personas que ya han encontrado la paz interior con SanaSivana.',
  testimonialsTitle: 'Qué dicen los usuarios',
  testimonial1: '"Tras dos semanas de meditaciones diarias noté que reaccionaba con mucha más calma ante el estrés. Conciliar el sueño se volvió más fácil."',
  testimonial1Author: 'Ana G.',
  testimonial1Role: 'Marketera',
  testimonial2: '"SanaSivana me ayudó a gestionar la ansiedad. Las prácticas duran solo 10 minutos y el efecto se nota a los pocos días."',
  testimonial2Author: 'David M.',
  testimonial2Role: 'Emprendedor',
  testimonial3: '"Aplicación cómoda, voces suaves, música agradable. La recomiendo a todos los que quieran reducir el estrés."',
  testimonial3Author: 'María L.',
  testimonial3Role: 'Médica',
  trustTitle: 'Nos preocupamos por tu seguridad',
  trustText: 'El servicio ha sido creado con la participación de psicólogos profesionales y especialistas en prácticas meditativas. Todos los datos se almacenan en servidores seguros.',
  trust1: 'Datos protegidos con cifrado SSL/TLS',
  trust2: 'Cifrado de transmisión de datos SSL/TLS',
  trust3: 'El servicio no es un servicio médico',
  finalCtaTitle: 'El primer paso hacia la paz interior — ahora mismo',
  finalCtaSubtitle: 'Únete a la comunidad de personas que cada día eligen la salud mental y la vida consciente.',
  loginViaTelegram: 'Iniciar sesión con Telegram',
  widgetNotConfigured: '⚠️ El widget de Telegram no está configurado',
  widgetSetupHint: 'Es necesario definir VITE_TELEGRAM_BOT_USERNAME en el archivo .env',
  retrying: 'Reintentando...',
  footerLogoDesc: 'Servicio online de meditaciones para la calma, el enfoque y el equilibrio interior.',
  footerDisclaimer: 'El servicio no es un servicio médico y no sustituye la atención médica profesional.',
  footerDocuments: 'Documentos',
  footerContacts: 'Contacto',
  footerModalClose: 'Cerrar',
  footerEmail: 'info@kyulchoro.kg',
  footerCopyright: '© 2026 SanaSivana. Todos los derechos reservados.',
  footerCompanyLegal: 'OOO «Kyulchoro»',
} as const;

const LogoIcon: React.FC<{ className?: string }> = ({ className }) => {
  const gradientId = React.useId().replace(/:/g, '');
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#22d3ee" />
          <stop offset="100%" stopColor="#a78bfa" />
        </linearGradient>
      </defs>
      <rect width="24" height="24" rx="6" fill={`url(#${gradientId})`} />
    <circle cx="12" cy="12" r="4" fill="white" fillOpacity="0.9" />
    <path d="M12 2C12 2 8 6 8 12C8 18 12 22 12 22C12 22 16 18 16 12C16 6 12 2 12 2Z" fill="white" fillOpacity="0.6" />
    <path d="M2 12C2 12 6 8 12 8C18 8 22 12 22 12C22 12 18 16 12 16C6 16 2 12 2 12Z" fill="white" fillOpacity="0.6" />
  </svg>
  );
};

interface UnauthorizedScreenProps {
  onRetry: () => void;
  isRetrying?: boolean;
  onLoginSuccess?: () => void;
}

export const UnauthorizedScreen: React.FC<UnauthorizedScreenProps> = ({
  onRetry: _onRetry,
  isRetrying = false,
  onLoginSuccess,
}) => {
  const r = LANDING_ES;
  const [docModal, setDocModal] = useState<{ title: string; text: string } | null>(null);
  const [testimonialIdx, setTestimonialIdx] = useState(0);
  const [loginModal, setLoginModal] = useState(false);
  const [authTab, setAuthTab] = useState<'telegram' | 'login' | 'register'>('login');
  const [emailForm, setEmailForm] = useState({ first_name: '', email: '', password: '' });
  const [authError, setAuthError] = useState('');
  const [authLoading, setAuthLoading] = useState(false);
  const tgWidgetContainerRef = useRef<HTMLDivElement>(null);

  const testimonials = [
    { quote: r.testimonial1, author: r.testimonial1Author, role: r.testimonial1Role },
    { quote: r.testimonial2, author: r.testimonial2Author, role: r.testimonial2Role },
    { quote: r.testimonial3, author: r.testimonial3Author, role: r.testimonial3Role },
  ] as const;

  const loadTgWidget = (container: HTMLElement) => {
    const botUsername = import.meta.env.VITE_TELEGRAM_BOT_USERNAME;
    if (!botUsername) return;
    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.setAttribute('data-telegram-login', botUsername);
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-radius', '8');
    const appUrl = import.meta.env.VITE_APP_URL || window.location.origin;
    script.setAttribute('data-auth-url', appUrl + '/api/telegram/auth');
    script.setAttribute('data-request-access', 'write');
    script.async = true;
    container.innerHTML = '';
    container.appendChild(script);
  };

  // Widget in hero section (outside modal) — keep existing behaviour
  useEffect(() => {
    const container = document.getElementById('telegram-login-container');
    if (container) loadTgWidget(container);
    return () => {
      const c = document.getElementById('telegram-login-container');
      if (c) c.innerHTML = '';
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Widget inside modal when telegram tab is active
  useEffect(() => {
    if (loginModal && authTab === 'telegram' && tgWidgetContainerRef.current) {
      loadTgWidget(tgWidgetContainerRef.current);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginModal, authTab]);

  const openLoginModal = (tab: 'telegram' | 'login' | 'register' = 'login') => {
    setAuthTab(tab);
    setAuthError('');
    setLoginModal(true);
  };

  const handleEmailAuth = async (e: React.FormEvent) => {
    e.preventDefault();
    setAuthError('');
    setAuthLoading(true);
    try {
      let result;
      if (authTab === 'register') {
        result = await apiClient.emailRegister({
          email: emailForm.email,
          password: emailForm.password,
          first_name: emailForm.first_name,
        });
      } else {
        result = await apiClient.emailLogin({
          email: emailForm.email,
          password: emailForm.password,
        });
      }
      if (result.success && result.token) {
        localStorage.setItem('email_auth_token', result.token);
        setLoginModal(false);
        onLoginSuccess?.();
      }
    } catch (err: unknown) {
      const msg = (err as { response?: { data?: { error?: string; message?: string } } })?.response?.data?.error
        || (err as { response?: { data?: { message?: string } } })?.response?.data?.message
        || 'Error al iniciar sesión';
      setAuthError(msg);
    } finally {
      setAuthLoading(false);
    }
  };

  useEffect(() => {
    const t = setInterval(() => {
      setTestimonialIdx((i) => (i + 1) % testimonials.length);
    }, 7000);
    return () => clearInterval(t);
  }, [testimonials.length]);

  return (
    <div className="landing">
      <header className="landing-header">
        <div className="landing-header-inner">
          <div className="landing-logo">
            <LogoIcon />
            <span>SanaSivana</span>
          </div>
          <div className="landing-header-actions">
            <button type="button" className="landing-header-login-link" onClick={() => openLoginModal('login')}>
              Iniciar sesión
            </button>
          </div>
        </div>
      </header>

      <main>
        {/* Hero */}
        <section className="landing-hero">
          <p className="landing-hero-subtitle">{r.subtitle}</p>
          <h1 className="landing-hero-title">{r.title}</h1>
          <p className="landing-hero-desc">{r.description}</p>
          <div className="landing-hero-cta">
            <button type="button" className="landing-cta-btn" onClick={() => openLoginModal('login')}>
              Iniciar sesión
            </button>
          </div>
          <div className="landing-stats">
            <span>🧘 {r.usersCount}</span>
            <span>⭐ {r.rating}</span>
            <span>📅 {r.meditationsCount}</span>
          </div>
          <div className="landing-sleep-badge">{r.sleepBadge}</div>
        </section>

        {/* What is SanaSivana */}
        <section className="landing-section landing-what">
          <div className="landing-what-inner">
            <div className="landing-what-content">
              <h2 className="landing-section-title">{r.whatTitle}</h2>
              <p className="landing-section-text">{r.whatText}</p>
              <div className="landing-benefits">
                <span>{r.benefit1}</span>
                <span>{r.benefit2}</span>
                <span>{r.benefit3}</span>
                <span>{r.benefit4}</span>
                <span>{r.benefit5}</span>
              </div>
              <div className="landing-features">
                <span>{r.feature1}</span>
                <span>{r.feature2}</span>
                <span>{r.feature3}</span>
                <span>{r.feature4}</span>
              </div>
            </div>
            <div className="landing-what-image-wrap">
              <img
                src="https://images.unsplash.com/photo-1632653859951-7d52ea5498ef?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHx3b21hbiUyMG1lZGl0YXRpbmclMjBwZWFjZWZ1bCUyMG1vcm5pbmclMjBuYXR1cmV8ZW58MXx8fHwxNzcyNDczMzY4fDA&ixlib=rb-4.1.0&q=80&w=1080"
                alt="Meditación en la naturaleza"
                className="landing-what-image"
              />
            </div>
          </div>
        </section>

        {/* Why */}
        <section className="landing-section landing-why">
          <h2 className="landing-section-title">{r.whyTitle}</h2>
          <div className="landing-why-grid">
            <div className="landing-why-col">
              <h3>🚩 {r.whyProblems}</h3>
              <ul>
                <li>😰 {r.problem1}</li>
                <li>😵 {r.problem2}</li>
                <li>😴 {r.problem3}</li>
                <li>🔥 {r.problem4}</li>
              </ul>
            </div>
            <div className="landing-why-col landing-why-col-success">
              <h3>✅ {r.whyPractices}</h3>
              <ul>
                <li>{r.practice1}</li>
                <li>{r.practice2}</li>
                <li>{r.practice3}</li>
                <li>{r.practice4}</li>
              </ul>
            </div>
          </div>
        </section>

        {/* How it works */}
        <section className="landing-section">
          <h2 className="landing-section-title">{r.howTitle}</h2>
          <div className="landing-steps">
            <div className="landing-step">
              <span className="landing-step-num">01</span>
              <h3>{r.step1Title}</h3>
              <p>{r.step1Text}</p>
            </div>
            <div className="landing-step">
              <span className="landing-step-num">02</span>
              <h3>{r.step2Title}</h3>
              <p>{r.step2Text}</p>
            </div>
            <div className="landing-step">
              <span className="landing-step-num">03</span>
              <h3>{r.step3Title}</h3>
              <p>{r.step3Text}</p>
            </div>
            <div className="landing-step">
              <span className="landing-step-num">04</span>
              <h3>{r.step4Title}</h3>
              <p>{r.step4Text}</p>
            </div>
          </div>
        </section>

        {/* Advantages */}
        <section className="landing-section">
          <h2 className="landing-section-title">{r.advantagesTitle}</h2>
          <div className="landing-advantages">
            <div className="landing-adv">
              <h3>{r.adv1Title}</h3>
              <p>{r.adv1Text}</p>
            </div>
            <div className="landing-adv">
              <h3>{r.adv2Title}</h3>
              <p>{r.adv2Text}</p>
            </div>
            <div className="landing-adv">
              <h3>{r.adv3Title}</h3>
              <p>{r.adv3Text}</p>
            </div>
            <div className="landing-adv">
              <h3>{r.adv4Title}</h3>
              <p>{r.adv4Text}</p>
            </div>
            <div className="landing-adv">
              <h3>{r.adv5Title}</h3>
              <p>{r.adv5Text}</p>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="landing-cta">
          <h2>{r.ctaTitle}</h2>
          <p>{r.ctaSubtitle}</p>
          <div className="telegram-login-section">
            <button type="button" className="landing-cta-btn" onClick={() => openLoginModal('login')}>
              Iniciar sesión
            </button>
          </div>
        </section>

        {/* Testimonials */}
        <section className="landing-section">
          <h2 className="landing-section-title">{r.testimonialsTitle}</h2>
          <div className="landing-testimonials-slider">
            <div className="landing-testimonials-track">
              {testimonials.map((t, i) => (
                <div
                  key={i}
                  className={`landing-testimonial-slide ${i === testimonialIdx ? 'active' : ''}`}
                >
                  <div className="landing-testimonial">
                    <blockquote>{t.quote}</blockquote>
                    <div className="landing-testimonial-author">
                      <span className="landing-testimonial-avatar">{t.author.charAt(0)}</span>
                      <div>
                        <strong>{t.author}</strong>
                        <span>{t.role}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="landing-testimonials-dots">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  className={`landing-testimonial-dot ${i === testimonialIdx ? 'active' : ''}`}
                  onClick={() => setTestimonialIdx(i)}
                  aria-label={`Reseña ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Trust */}
        <section className="landing-section landing-trust">
          <h2 className="landing-section-title">{r.trustTitle}</h2>
          <p className="landing-section-text">{r.trustText}</p>
          <ul className="landing-trust-list">
            <li>{r.trust1}</li>
            <li>{r.trust2}</li>
            <li>{r.trust3}</li>
          </ul>
        </section>

        {/* Final CTA */}
        <section className="landing-cta landing-final-cta">
          <h2>{r.finalCtaTitle}</h2>
          <p>{r.finalCtaSubtitle}</p>
          <div className="telegram-login-section">
            <button type="button" className="landing-cta-btn" onClick={() => openLoginModal('login')}>
              Iniciar sesión
            </button>
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <div className="landing-footer-inner">
          <div className="landing-footer-cols">
            <div className="landing-footer-col landing-footer-brand">
              <div className="landing-footer-logo">
                <LogoIcon />
                <span>SanaSivana</span>
              </div>
              <p className="landing-footer-desc">{r.footerLogoDesc}</p>
              <p className="landing-footer-disclaimer">
                <span className="landing-footer-disclaimer-icon">⚠</span>
                {r.footerDisclaimer}
              </p>
            </div>
            <div className="landing-footer-col">
              <h3 className="landing-footer-heading">{r.footerDocuments}</h3>
              {FOOTER_DOCS.map((doc) => (
                <button
                  key={doc.title}
                  type="button"
                  className="landing-footer-link landing-footer-doc-link"
                  onClick={() => setDocModal(doc)}
                >
                  {doc.title}
                </button>
              ))}
            </div>
            <div className="landing-footer-col">
              <h3 className="landing-footer-heading">{r.footerContacts}</h3>
              <a href={`mailto:${r.footerEmail}`} className="landing-footer-link">{r.footerEmail}</a>
            </div>
          </div>
          <div className="landing-footer-bottom">
            <span>{r.footerCopyright}</span>
            <span>{r.footerCompanyLegal}</span>
          </div>
        </div>
      </footer>

      {docModal && (
        <div className="landing-doc-modal-overlay" onClick={() => setDocModal(null)}>
          <div className="landing-doc-modal" onClick={(e) => e.stopPropagation()}>
            <div className="landing-doc-modal-header">
              <h3 className="landing-doc-modal-title">{docModal.title}</h3>
              <button type="button" className="landing-doc-modal-close" onClick={() => setDocModal(null)}>
                {r.footerModalClose}
              </button>
            </div>
            <div className="landing-doc-modal-body">
              <pre className="landing-doc-modal-text">{docModal.text}</pre>
            </div>
          </div>
        </div>
      )}

      {isRetrying && (
        <div className="landing-retry-overlay">
          <span className="retry-spinner"></span>
          <span>{r.retrying}</span>
        </div>
      )}

      {loginModal && (
        <div className="auth-modal-overlay" onClick={() => setLoginModal(false)}>
          <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="auth-modal-close" onClick={() => setLoginModal(false)}>✕</button>
            <h2 className="auth-modal-title">Iniciar sesión</h2>

            <div className="auth-modal-tabs">
              <button type="button" className={`auth-tab ${authTab === 'telegram' ? 'active' : ''}`} onClick={() => setAuthTab('telegram')}>
                Telegram
              </button>
              <button type="button" className={`auth-tab ${authTab === 'login' ? 'active' : ''}`} onClick={() => setAuthTab('login')}>
                Correo
              </button>
              <button type="button" className={`auth-tab ${authTab === 'register' ? 'active' : ''}`} onClick={() => setAuthTab('register')}>
                Registro
              </button>
            </div>

            {authTab === 'telegram' && (
              <div className="auth-tab-content">
                <p className="auth-tab-hint">Usa tu cuenta de Telegram para entrar:</p>
                {import.meta.env.VITE_TELEGRAM_BOT_USERNAME ? (
                  <div ref={tgWidgetContainerRef} className="auth-tg-widget"></div>
                ) : (
                  <div className="widget-error">
                    <p>{r.widgetNotConfigured}</p>
                    <small>{r.widgetSetupHint}</small>
                  </div>
                )}
              </div>
            )}

            {(authTab === 'login' || authTab === 'register') && (
              <form className="auth-email-form" onSubmit={handleEmailAuth}>
                {authTab === 'register' && (
                  <div className="auth-field">
                    <label>Nombre</label>
                    <input
                      type="text"
                      value={emailForm.first_name}
                      onChange={(e) => setEmailForm({ ...emailForm, first_name: e.target.value })}
                      placeholder="Tu nombre"
                      required
                    />
                  </div>
                )}
                <div className="auth-field">
                  <label>Correo electrónico</label>
                  <input
                    type="email"
                    value={emailForm.email}
                    onChange={(e) => setEmailForm({ ...emailForm, email: e.target.value })}
                    placeholder="tu@email.com"
                    required
                  />
                </div>
                <div className="auth-field">
                  <label>Contraseña</label>
                  <input
                    type="password"
                    value={emailForm.password}
                    onChange={(e) => setEmailForm({ ...emailForm, password: e.target.value })}
                    placeholder={authTab === 'register' ? 'Mínimo 6 caracteres' : '••••••••'}
                    minLength={6}
                    required
                  />
                </div>
                {authError && <p className="auth-error">{authError}</p>}
                <button type="submit" className="auth-submit-btn" disabled={authLoading}>
                  {authLoading ? 'Cargando...' : authTab === 'register' ? 'Registrarse' : 'Entrar'}
                </button>
                <p className="auth-switch-hint">
                  {authTab === 'login' ? (
                    <>¿No tienes cuenta? <button type="button" className="auth-switch-link" onClick={() => setAuthTab('register')}>Regístrate</button></>
                  ) : (
                    <>¿Ya tienes cuenta? <button type="button" className="auth-switch-link" onClick={() => setAuthTab('login')}>Inicia sesión</button></>
                  )}
                </p>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
